<template>
    <div class="row">
        <div class="col-12 pt-3 small">
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <trade-mark-icon height="16" width="16"
                                         class="qf-va-sub mr-2"></trade-mark-icon>
                        {{$ml.get('Trademark')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{(trademark.title!=='')?trademark.title:$ml.get('not_available')}}</strong>
                    </div>
                </div>
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <tracked-by-icon height="18" width="18"
                                         class="qf-va-sub mr-2"></tracked-by-icon>
                        {{$ml.get('Tracked_by')}}
                    </div>
                    <div class="py-3 pr-3 w-50">
                        {{$ml.get('not_available')}}
                        <!--<template v-for="(item, index) in trackedBy">-->
                        <!--<strong>{{$ml.get(item)}}</strong>-->
                        <!--<span v-if="index !== (trackedBy.length -1)">, </span>-->
                        <!--</template>-->
                        <!--<strong>asdasd</strong>-->
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <kind-icon height="16" width="16" class="qf-va-sub mr-2"></kind-icon>
                        {{$ml.get('Type')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.type}}</strong></div>
                </div>
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <status-icon height="18" width="18" class="qf-va-sub mr-2"></status-icon>
                        {{$ml.get('Status')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.status}}</strong></div>
                </div>
            </div>
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <number-of-request-icon height="18" width="18"
                                                class="qf-va-sub mr-2"></number-of-request-icon>
                        {{$ml.get('Application_Number')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.application_number}}</strong>
                    </div>
                </div>
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <registration-date-icon height="15" width="15"
                                                class="qf-va-sub mr-2"></registration-date-icon>
                        {{$ml.get('Application_Date')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.application_date | dateFormat}}</strong>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <registration-number-icon height="15" width="15"
                                                  class="qf-va-sub mr-2"></registration-number-icon>
                        {{$ml.get('Registration_Number')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.register_number?trademark.register_number:$ml.get('not_available')}}</strong>
                    </div>
                </div>
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <registration-date-icon height="15" width="15"
                                                class="qf-va-sub mr-2"></registration-date-icon>
                        {{$ml.get('Date_Of_Registration')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.registration_date | dateFormat}}</strong></div>
                </div>
            </div>
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <owner-icon height="18" width="18" class="qf-va-sub mr-2"></owner-icon>
                        {{$ml.get('Owner')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.owner.name?trademark.owner.name:trademark.owner.identifier}}</strong>
                    </div>
                </div>
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <owner-address-icon height="17" width="17"
                                            class="qf-va-sub mr-2"></owner-address-icon>
                        {{$ml.get('Owners_Address')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.owner.address?trademark.owner.address:$ml.get('not_available')}}</strong>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <good-service-icon height="16" width="16"
                                           class="qf-va-sub mr-2"></good-service-icon>
                        {{$ml.get('Vienna_Classes')}}
                    </div>
                    <div class="py-3 pr-3 w-50">
                        <template v-for="(vienna_class, index) in trademark.vienna_classes">
                            <a href="#!"
                               :key="`tm-a-${index}`"
                               @click.prevent v-b-tooltip.hover
                               :title="vienna_class.description"
                               class="qf-tooltip">
                                <strong>{{vienna_class.class_id}}</strong>
                            </a>
                            <span v-if="index !== (trademark.vienna_classes.length -1)" :key="`tm-span-${index}`">, </span>
                        </template>
                    </div>
                </div>
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <good-service-icon height="18" width="18"
                                           class="qf-va-sub mr-2"></good-service-icon>
                        {{$ml.get('Nice_Classes')}}
                    </div>
                    <div class="py-3 pr-3 w-50">
                        <template v-for="(nice_class, index) in trademark.nice_classes">
                            <a href="#!"
                               :key="`tm-a-${index}`"
                               @click.prevent v-b-tooltip.hover
                               :title="nice_class.description"
                               class="qf-tooltip"><strong>{{nice_class.class_num?nice_class.class_num:nice_class.class}}</strong></a><span
                                v-if="index !== (trademark.nice_classes.length -1)" :key="`tm-span-${index}`">, </span>
                        </template>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50 d-flex align-items-center">
                        <department-icon height="17" width="17"
                                         class="qf-va-sub mr-2"></department-icon>
                        {{$ml.get('Country_Of_Origin')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.office_of_origin}}</strong></div>
                </div>
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <protection-icon height="16" width="16"
                                         class="qf-va-sub mr-2"></protection-icon>
                        {{$ml.get('Expiration_Date')}}
                    </div>
                    <div class="py-3 pr-3 w-50"><strong>{{trademark.expired_on?trademark.expired_on:trademark.contestation
                        | dateFormat}}</strong></div>
                </div>
            </div>
            <div class="d-flex flex-column flex-md-row align-items-stretch">
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <number-of-request-icon height="18" width="18"
                                                class="qf-va-sub mr-2"></number-of-request-icon>
                        {{$ml.get('Designated_countries')}}
                    </div>
                    <div class="py-3 pr-3 w-50">
                        <template v-for="(country, index) in trademark.designated_country">
                            <a href="#!"
                               :key="`tm-a-${index}`"
                               @click.prevent v-b-tooltip.hover
                               :title="country"
                               class="qf-tooltip">
                                <strong>{{country}}</strong>
                            </a>
                            <span v-if="index !== (trademark.designated_country.length -1)" :key="`tm-span-${index}`">, </span>
                        </template>
                    </div>
                </div>
                <div class="w-50 m-1 qf-bg-white d-flex align-items-center">
                    <div class="py-3 pl-3 w-50">
                        <colors-icon height="18" width="18" class="qf-va-sub mr-2"></colors-icon>
                        {{$ml.get('Colors')}}
                    </div>
                    <div class="py-3 pr-3 w-50">
                        <strong>{{trademark.colors?trademark.colors:$ml.get('not_available')}}</strong></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TrademarkDetails",
        props: {
            trademark: Object
        }
    }
</script>

<style scoped>
    .qf-bg-white.w-50 {
        width: auto !important;
    }

    @media (min-width: 576px) {
    }


    @media (min-width: 768px) {
        .qf-bg-white.w-50 {
            width: 50% !important;
        }
    }
</style>
